import { render, staticRenderFns } from "./MFolderTree.vue?vue&type=template&id=e50d4ec8&scoped=true&"
import script from "./MFolderTree.vue?vue&type=script&setup=true&lang=js&"
export * from "./MFolderTree.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50d4ec8",
  null
  
)

export default component.exports